import { Carriers } from '../constants/carriers';
import { DebitsValue } from '../constants/decision';
import { Products } from '../constants/products';
import { UserOrganization } from '../constants/userOrganization';

export enum EvidenceOrderProfile {
  INSURED = 'INSURED',
  OWNER = 'OWNER',
}

export abstract class ProductConfig {
  public abstract getCarrier(): Carriers;
  public abstract getProduct(): Products;

  /**
   * Returns the product subCategory/variant (e.g., 'JUVENILE' for Sahara Juvenile).
   * Base products return empty string.
   */
  public getSubCategory(): string {
    return '';
  }
  public abstract availableToOrganization(org: UserOrganization): boolean;
  public abstract getColor(): string;
  public showInErrorTasks(): boolean {
    return true;
  }
  public medicalClaimAvailable(): boolean {
    return true;
  }
  public automatedCriminalRecordsAvailable(): boolean {
    return true;
  }
  public TRLAvailable(): boolean {
    return false;
  }
  public hasDebits(): boolean {
    return true;
  }
  public getDebitsList(): DebitsValue[] {
    return [];
  }
  public hasRateClass(): boolean {
    return true;
  }
  public isRateClassAvailable(_rateClass: string): boolean {
    return true;
  }
  public showPolicyCombined(_rules: string[], _org: string) {
    return false;
  }
  public showPercentageAddition(_rate: string | undefined) {
    return false;
  }
  public showDebits(_rate: string | undefined): boolean {
    return false;
  }
  public hasPercentageAddition(): boolean {
    return false;
  }
  public hasTableRating(): boolean {
    return false;
  }
  public medicalExamAvailable(): boolean {
    return false;
  }
  public scriptCheckAvailable(): boolean {
    return false;
  }
  public ETIAvailable(): boolean {
    return false;
  }
  public hasAutoMedicalClaimRunButton(): boolean {
    return false;
  }
  public getPa(debits: number): number {
    return debits + 100;
  }
  public hasStandardPlusRating(_flags?: any): boolean {
    return false;
  }
  public showTobaccoForPreferred(_flags?: any): boolean {
    return false;
  }
  public getUnderWritableRiders(_state: string): string[] {
    return [];
  }
  /**
   * Optional: when an underwritable (source) rider's eligibility changes,
   * update a dependent (target) rider, e.g. for mutual exclusivity.
   * Default: no rules.
   */
  public getRiderExclusivityRules(
    _state: string,
  ): { sourceRider: string; targetRider: string; inverse: boolean }[] {
    return [];
  }
  public supportsFamilyCoverageDetails(): boolean {
    return false;
  }
  public supportsOwnerInsuredSplit(): boolean {
    return false;
  }
  public shouldRenderOwnerOverview(): boolean {
    return this.supportsOwnerInsuredSplit();
  }
  public shouldRenderOwnerLinkedPolicies(): boolean {
    return this.supportsOwnerInsuredSplit();
  }
  public shouldSendLettersToOwner(): boolean {
    return this.supportsOwnerInsuredSplit();
  }
  public getEvidenceOrderProfile(_evidenceType?: string): EvidenceOrderProfile {
    return EvidenceOrderProfile.INSURED;
  }
  public getProductDisplayText(): string {
    return `${this.getCarrier()} ${this.getProduct()}`;
  }
}
